import { UploadFile } from 'antd'
import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import { ICollection, ICreateCollection, IPopulatedCollection } from 'models/collections'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'

type CreateCollectionBody = Omit<ICreateCollection, 'photo'> & { photo: UploadFile[] }

export const collectionsApi = {
  getCollections: (): Promise<AxiosResponse<ICollection[]>> => {
    return privateApi.get('/collections', { params: { limit: 100, skip: 0 } })
  },
  createCollection: (data: CreateCollectionBody) => {
    const formData = getNormalizedFormData(data)
    return privateApi.post('/collections', formData)
  },
  getCollection: (id: string): Promise<AxiosResponse<IPopulatedCollection>> => {
    return privateApi.get(`admin/collections/${id}`)
  },
  updateCollection: (id: string, data: CreateCollectionBody) => {
    const formData = getNormalizedFormData(data)
    return privateApi.patch(`/collections/${id}`, formData)
  },
  // ids — незакреплённые опубликованные в новом порядке
  reorderCollections: (ids: string[]) => {
    return privateApi.patch('/admin/collections/order', { ids })
  },
  deleteCollection: (id: string) => {
    return privateApi.delete(`/collections/${id}`)
  }
}
